import React from 'react';
import styled from '@emotion/styled';
import { Chip } from '@bucketplace/design-system';

import { StoreItemFilter } from '@/contexts';

interface RankingStoreItemFilterProps {
  options: StoreItemFilter[];
  value: StoreItemFilter | null;
  onChange?(value: StoreItemFilter | null): void;
}

export function RankingStoreItemFilter(props: RankingStoreItemFilterProps) {
  const { options, value, onChange } = props;

  if (options.length === 0) {
    return null;
  }

  return (
    <Root>
      <Chip
        size="sm"
        variant={value === null ? 'solid' : 'normal'}
        onClick={() => {
          onChange?.(null);
        }}
      >
        <Chip.Slot side="center">
          <Chip.Label>
            전체
          </Chip.Label>
        </Chip.Slot>
      </Chip>

      { options.map((option) => {
        return (
          <Chip
            key={option.name}
            size="sm"
            variant={value?.name === option.name && value.type === option.type ? 'solid' : 'normal'}
            onClick={() => {
              onChange?.(option);
            }}
          >
            <Chip.Slot side="center">
              <Chip.Label>{ option.name }</Chip.Label>
            </Chip.Slot>
          </Chip>
        );
      }) }
    </Root>
  );
}

const Root = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 0 36px 8px 16px;
  overflow-x: auto;
`;
